import { ref } from "vue";

interface UseRadiusCircle {
  radiusCircle: any;
  createRadiusCircleOnCenter: (map: any, radiusMeter: number) => void;
  updateRadiusCircleOnCenter: (map: any, radiusMeter: number) => void;
}

export const useRadiusCircle = (): UseRadiusCircle => {
  const radiusCircle = ref();

  const createRadiusCircleOnCenter = (map: any, radiusMeter: number) => {
    const center = map.getCenter();

    radiusCircle.value = new window.naver.maps.Circle({
      map,
      center,
      radius: radiusMeter,
      strokeStyle: "dash",
      strokeWeight: 2,
      strokeColor: "#8dcd33",
      fillColor: "#8dcd33",
      fillOpacity: 0.1,
    });
  };

  const updateRadiusCircleOnCenter = (map: any, radiusMeter: number) => {
    const center = map.getCenter();

    radiusCircle.value.setCenter(center);
    radiusCircle.value.setRadius(radiusMeter);
  };

  return {
    radiusCircle,
    createRadiusCircleOnCenter,
    updateRadiusCircleOnCenter,
  };
};
